export default "__VITE_ASSET__BNDhL9OS__"